import Router from 'vue-router'
import Vue from 'vue'

import Home from '@/views/Home' //首页
Vue.use(Router)


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }


export default new Router({
  routes: [
    {
      path:'/',
      name: 'Home',
      component:Home,
      meta:{title: '首页'}
    }
  ]
})
